// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1hvjR","overflowing":"ReadFullNote_overflowing__1HYuW"};